import React, {Component} from "react";
import './CustomerOrderTableRow.css';
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {Modal} from "react-bootstrap";
import PrintOrder from "../PrintOrder";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../../configuration";
import OrderItem from "../OrderItem/OrderItem";
import NumberFormatter from "../../../../Common/NumberFormatter/NumberFormatter";
import {Redirect} from "react-router-dom";
import $ from "jquery";
import canvasDown from "../../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../../assets/img/canvasup.png";
import "../NewOrderHistoryTable.css";

const styles = {
    test: {
        height: (props) => props.open ? 20 : 0
    }
};

const GetStatusLocale = (props) => {

    let status = props.status;
    let statusText = "N/A";

    if (status === "PENDING") {

        statusText = <FormattedMessage id="app.order.history.status.pending-review"
                                       defaultMessage="Pending Review"
                                       description=""/>;
    } else if (status === "CANCELLED") {
        statusText = <FormattedMessage id="app.order.history.status.cancel"
                                       defaultMessage="Cancel"
                                       description=""/>;
    } else if (status === "CONFIRMED") {
        statusText = <FormattedMessage id="app.order.history.status.confirm"
                                       defaultMessage="Confirm"
                                       description=""/>;
    } else if (status === "IN_WAREHOUSE") {
        statusText = <FormattedMessage id="app.order.history.status.ordered"
                                       defaultMessage="In wherehouse"
                                       description=""/>;
    } else if (status === "IN_PRODUCTION") {
        statusText = <FormattedMessage id="app.order.history.status.in-production"
                                       defaultMessage="In production"
                                       description=""/>;
    } else if (status === "SHIPPED") {
        statusText = <FormattedMessage id="app.order.history.status.shipped"
                                       defaultMessage="Shipped"
                                       description=""/>;
    } else if (status === "DELIVERED") {
        statusText = <FormattedMessage id="app.order.history.status.delivered"
                                       defaultMessage="Delivered"
                                       description=""/>;
    }

    return statusText;
};

class CustomerOrderTableRow extends Component {

    constructor(props) {
        super(props);
        this.state = {
            show: false,
            status: '',
            orderData: [],
            orderItems: [],
            billOrderInfo: [],
            shipOrderInfo: [],
            chargeDetails: [],
            statusData: [],
            statusCode: "",
            ItemStatusResult: [],
            stat: 1,
            buildTimeArray: [],
            showReorderComponents: false,
            showReorderConfirm: false,
            reorderParams: {},
            checkedReorderItems: [],
            reorderItemSummary: {},
            sagawaCodes: []

        };
        this.handleShow = this.handleShow.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getOrderStatus = this.getOrderStatus.bind(this);
        this.calculateOrderStatus = this.calculateOrderStatus.bind(this);
        this.setOrderStatus = this.setOrderStatus.bind(this);
        this.showReorderComponents = this.showReorderComponents.bind(this);
        this.handleCloseReorderConfirm = this.handleCloseReorderConfirm.bind(this);
        this.handleShowReorderConfirm = this.handleShowReorderConfirm.bind(this);
        this.setReorderItems = this.setReorderItems.bind(this);
        this.createReorder = this.createReorder.bind(this);
        this.getSagawaCodesForOrder = this.getSagawaCodesForOrder.bind(this);
    }

    getSagawaCodesForOrder = () => {
        axios.get(RESOURCE_BASE_URL + 'api/order/' + this.props.order.id + '/track/sagawa')
            .then((res) => {
                this.setState({
                    sagawaCodes: res.data,

                });
                // console.log("sagawa codes",res.data)

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });
    };

    setReorderItems = (itemUuid, qtyValue, type) => {
        //type is smt or pcb
        let reorderParams = {...this.state.reorderParams};

        if (type === "pcb") {
            reorderParams[itemUuid] = {
                itemUUID: itemUuid,
                reorderPcbQty: qtyValue,
                reorderSmtQty: reorderParams[itemUuid].reorderSmtQty
            };
        } else {
            reorderParams[itemUuid] = {
                itemUUID: itemUuid,
                reorderPcbQty: reorderParams[itemUuid].reorderPcbQty,
                reorderSmtQty: qtyValue
            };
        }

        this.setState({
            reorderParams
        }, () => console.log("REORDER PARAMS UPDATED ===> "))
    };

    createReorder = (orderId) => {
        // console.log("CREATING REORDER PARAMS DUO ====> ", Object.values(this.state.reorderParams));

        let orderResourceUrl = RESOURCE_BASE_URL + 'api/users/' + this.props.userId + '/reorder/' + orderId;
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
            }
        };

        axios.post(orderResourceUrl, Object.values(this.state.reorderParams), axiosConfig)
            .then((res) => {
                // console.log("ORDER CART ITEMS DUO ====> ", res.data);

                this.setState({
                    checkedReorderItems: res.data.cartItemIds,
                    reorderItemSummary: res.data.summary,
                    redirect: true
                }, () => this.props.getCartItems())

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });


    };

    handleCloseReorderConfirm = () => {
        this.setState({
            showReorderConfirm: false,
        }, () => this.showReorderComponents(false))
    };

    handleShowReorderConfirm = () => {
        this.setState({
            showReorderConfirm: true
        })
    };


    handleShow = () => {
        if (this.props.order.shippedDate !== null) {
            this.getSagawaCodesForOrder()
        }
        this.setState({
            show: true,

        });
    };

    showReorderComponents = (status) => {
        this.setState({
            showReorderComponents: status
        });
    };

    handleClose = () => {
        this.setState({show: false});
    };


    getOrderStatus = (batchNumber) => {

        axios.get(RESOURCE_BASE_URL + 'api/jlcpcb/order/status/' + this.props.orders.orderUUID + '/' +this.props.orders.id)
            .then((res) => {
                this.setState({
                    statusData: res.data,
                    statusCode: res.data.orderStatus,
                    ItemStatusResult: res.data.jlcpcbOrderStatusDto.result.orderItem,
                    // status:this.calculateOrderStatus()
                }, () => this.setOrderStatus());

                /* let temp2 = this.calculateOrderStatus();
                 this.setState({status:temp2});*/

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);

            });

    };

    calculateOrderStatus() {
        let stat = 5;
        let textStat;
        let buildArr = [];
        for (let i in this.state.ItemStatusResult) {
            let order = this.state.ItemStatusResult[i];
            let tempStat;
            if (order.orderType === 1 || order.orderType === 2 || order.orderType === 0) {
                buildArr.push(order.pcbItem.buildTime);
                tempStat = order.pcbItem.orderStatus;
                if (tempStat < stat) {
                    stat = tempStat;
                    // this.setState({stat:tempStat})
                }
            }
            if (order.orderType === 3) {
                buildArr.push(order.smtItem.buildTime);
                tempStat = order.smtItem.orderStatus;
                if (tempStat < stat) {
                    stat = tempStat;
                    // this.setState({stat:tempStat})
                }
            }
        }
        this.state.buildTimeArray = buildArr;
        if (stat === 1) {
            textStat = <FormattedMessage id="app.order.history.status.cancel"
                                         defaultMessage="Cancel"
                                         description=""/>;
        }
        if (stat === 0) {
            textStat = <FormattedMessage id="app.order.history.status.pending-review"
                                         defaultMessage="Pending Review"
                                         description=""/>;
        }
        if (stat === 2) {
            textStat = <FormattedMessage id="app.order.history.status.confirm"
                                         defaultMessage="Confirm"
                                         description=""/>;
        }
        if (stat === 3) {
            textStat = <FormattedMessage id="app.order.history.status.ordered"
                                         defaultMessage="Ordered"
                                         description=""/>;
        }
        if (stat === 4) {
            textStat = <FormattedMessage id="app.order.history.status.in-production"
                                         defaultMessage="In production"
                                         description=""/>;
        }
        if (stat === 5) {
            textStat = <FormattedMessage id="app.order.history.status.shipped"
                                         defaultMessage="Shipped"
                                         description=""/>;
        }
        if (stat === 6) {
            textStat = <FormattedMessage id="app.order.history.status.delivered"
                                         defaultMessage="Delivered"
                                         description=""/>;
        }
        if (stat === 7) {
            textStat = <FormattedMessage id="app.order.history.status.warehouse"
                                         defaultMessage="In Warehouse"
                                         description=""/>;
        }
        this.setState({stat: stat});
        return textStat;
    }

    setOrderStatus() {
        this.setState({status: this.calculateOrderStatus()})
    }


    componentDidMount() {
        let reorderObjects = {...this.state.reorderParams};
        this.props.order.reorderParams.forEach(param => {
            reorderObjects[param.itemUUID] = param
        });
        this.setState({
            reorderParams: reorderObjects
        })

        var collapsed = true;

        setTimeout(() => {

            $('.btnCollapse').children('.minus').hide()

            $(".btnCollapse").click(function () {
                collapsed = !collapsed;
                if (collapsed) {
                    $(this).children('.minus').hide()
                    $(this).children('.plus').show()
                    $(this).parent().parent().children('.collapseContent').slideUp('slow');
                } else {

                    $(this).children('.plus').hide()
                    $(this).children('.minus').show()
                    $(this).parent().parent().children('.collapseContent').slideDown('slow');
                }
            });
        }, 100)


    }


    render() {

        const goTo = {
            pathname: '/order/confirmation',
            selectedItems: this.state.checkedReorderItems,
            cartSummary: this.state.reorderItemSummary
        };

        const unavailableStatus = 6;
        let no = -1;
        let orderTotalFromChargeDetails = 0;
        let initDeliveryDate = '';
        let build = '';


        let height = 196 * this.props.order.orderItems.length;
        let tableHeightStyle = {
            height: height + 'px'
        }
        // console.log("=====================height height height =========== " , tableHeightStyle)


        // console.log("ORDER DUO REORDER !!! ====> ", this.state.reorderParams);
        return (
            <div className="row customer-info-order-row-margin">
                {this.state.redirect === true ?
                    <Redirect to={goTo}/> : ""
                }
            <div className="new-order-history-table">
                <div className="new-order-history-header">
                    <div className="new-order-history-upper">
                        <div className="col-md-5 new-left"><b>{this.props.order.createdOn.substring(0, this.props.order.createdOn.length - 9)}</b></div>
                        <div className="col-md-7 new-right"> <b>{this.props.order.batchNumber}</b></div>
                    </div>
                    <table className="table" border="1">
                        <thead>
                        <tr>
                            <th className="new-column-1">注文商品</th>
                            <th className="new-column-2">製品・ファイル</th>
                            <th className="new-column-3">価格</th>
                            <th className="new-column-4">進捗</th>
                            <th className="new-column-5">帳票</th>
                        </tr>
                        </thead>
                    </table>
                </div>
                <div className="new-order-history-row">

                    <div className="row no-margin order-header-margin">
                        <div className="col-md-7 header-highlight-border div-row7">
                            {this.props.order.orderItems.map(orderItem => {
                                let orderTotalJson = orderItem.chargeDetails.pricingResponse;
                                let total = orderTotalJson.total;
                                orderTotalFromChargeDetails = orderTotalFromChargeDetails + total;
                                /* let productionProgress='';
                                 this.state.ItemStatusResult.map(function(itemStatus, i){
                                    if(i===no){
                                        if(itemStatus.orderType===1){
                                            productionProgress=itemStatus.pcbItem.orderStatus;
                                        }
                                        if(itemStatus.orderType===3){
                                            productionProgress=itemStatus.smtItem.orderStatus;
                                        }
                                    }
                                 });*/

                                no++;
                                this.state.buildTimeArray.push(orderItem.buildTime);
                                return <OrderItem orderItem={orderItem}
                                                  orderNo={this.props.order.id}
                                                  statusCode={this.state.statusCode}
                                                  status={this.props.order.status}
                                                  order={this.props.order}
                                                  build={this.state.buildTimeArray[no]}
                                                  email={this.props.order.userInfo.email}
                                                  showReorderComponents={this.state.showReorderComponents}
                                                  setReorderItems={this.setReorderItems}
                                                  reorderParams={this.state.reorderParams}
                                />


                            })}

                            {/*{this.state.orderItems.map(orderItems => {
                                return <OrderItem orderItems={orderItems}
                                                  buildTime={this.state.chargeDetails.buildTime}/>

                            })}*/}

                        </div>
                        <div className=" col-md-2 total-div div-row2l border-customer-order-special new-order-history-column"
                             style={tableHeightStyle}>
                            <FormattedMessage id="app.order.history.table.order-merchandise-total"
                                              defaultMessage="Merchandise Total"
                                              description=""/><br/>
                            <label className="order-total-label">
                                {/*¥{orderTotalFromChargeDetails}*/}
                                ¥<NumberFormatter num={this.props.order.orderTotal}/>
                            </label>
                        </div>
                        <div className="col-md-2 div-row2r border-customer-order new-order-history-column" id="ship-text"
                             style={tableHeightStyle}>
                            <div className="spacer"></div>

                            <GetStatusLocale status={this.props.order.status}/>
                            <br/>
                            <FormattedMessage id="app.order.history.table.shipping-method"
                                              defaultMessage="Shipping Method"
                                              description=""/> :<br/>SGX(佐川国際宅配便)<br/>
                            <a className="btn track-btn no-padding" onClick={this.handleShow}>
                                    <span>
                                        <FormattedMessage id="app.admin-all-row.track"
                                                          defaultMessage="Track"
                                                          description=""/>
                                        </span>


                            </a>

                        </div>
                        <div className="col-md-1 div-row1 border-customer-order new-order-history-column" id="order-action-content-div"
                             style={tableHeightStyle}>
                            <div className="spacer"></div>
                            {/* <button className="btn btn-xs btn-success ">
                                <FormattedMessage
                                id="app.order.history.table.pay"
                                defaultMessage="Pay"
                                description=""/></button>
                            <br/>*/}

                            {/*{this.state.showReorderComponents === false ?*/}
                            {/*<span>*/}
                            {/*<span className="btn btn-xs reorder-modal-btn" onClick={()=>this.showReorderComponents(true)}>*/}
                            {/*再注文*/}
                            {/*</span><br/>*/}
                            {/*</span>*/}

                            {/*:*/}

                            {/*<span>*/}
                            {/*<span className="btn btn-xs reorder-modal-btn-create"*/}
                            {/*onClick={this.handleShowReorderConfirm}>*/}
                            {/*注文*/}
                            {/*</span><br/>*/}
                            {/*<span className="btn btn-xs reorder-modal-btn-cancel"*/}
                            {/*onClick={() => this.showReorderComponents(false)}>*/}
                            {/*キャンセル*/}
                            {/*</span><br/>*/}
                            {/*</span>*/}
                            {/*}*/}


                            <Link to={"/order/view/" + this.props.order.id} className="view-act-btn">
                                <FormattedMessage id="app.admin-all-row.view-order"
                                                  defaultMessage="Order Details"
                                                  description=""/>
                            </Link><br/>
                            {this.state.stat === '' ?
                                <PrintOrder orderId={this.props.order.id}
                                            orderStat={unavailableStatus}
                                            batchNumber={this.props.order.batchNumber}/> :
                                <PrintOrder orderId={this.props.order.id}
                                            orderStat={this.state.stat}
                                            batchNumber={this.props.order.batchNumber}/>
                            }
                            <br/>
                            <br/>
                            {this.props.order.refunded ?
                                <button disabled={true} className="btn btn-danger btn-xs">
                                    払い戻し済み
                                </button>
                                :
                                ""
                            }
                            {/*reorder----------------------------------*/}
                            {/*<ReorderModal orderId={this.props.order.id}*/}
                            {/*userInfo ={this.props.order.userInfo}/>*/}
                        </div>

                    </div>
                    {/*<div className="spacer"></div>*/}

                </div>
            </div>

                <div className="responsive-userAddress-table-mobile">
                    <div className="title-background1-responsive ">
                        <div className="custom-col-4">
                            <b>{this.props.order.createdOn.substring(0, this.props.order.createdOn.length - 9)}</b>
                        </div>
                        <div className="custom-col-6 order-history-batch-number-resp">{}&nbsp;&nbsp;
                            <b>{this.props.order.batchNumber}</b>
                        </div>
                        <div className="custom-col-1 float-right-plus btnCollapse">
                            <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                            <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                        </div>
                        <div className="custom-col-1"></div>

                    </div>
                    <hr/>
                    <div className="collapseContent collapseContent-profile set-padding-responsive-profile">
                        <div>
                            <div className="title-background2-responsive ">
                                <div className='custom-col-4'></div>
                                <div className="custom-col-6 text-align-cus-order">
                                    <FormattedMessage id="app.order.history.table-header.order-item"
                                                      defaultMessage="Order Item"
                                                      description=""/>
                                </div>
                                <div className="custom-col-1 float-right-plus btnCollapse">
                                    <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                    <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                                </div>
                                <div className="custom-col-1"></div>
                            </div>


                            <div className="collapseContent">
                                {this.props.order.orderItems.map(orderItem => {
                                    let orderTotalJson = orderItem.chargeDetails.pricingResponse;
                                    let total = orderTotalJson.total;
                                    orderTotalFromChargeDetails = orderTotalFromChargeDetails + total;
                                    no++;
                                    this.state.buildTimeArray.push(orderItem.buildTime);
                                    return <OrderItem orderItem={orderItem}
                                                      orderNo={this.props.order.id}
                                                      statusCode={this.state.statusCode}
                                                      status={this.props.order.status}
                                                      order={this.props.order}
                                                      build={this.state.buildTimeArray[no]}
                                                      email={this.props.order.userInfo.email}
                                                      showReorderComponents={this.state.showReorderComponents}
                                                      setReorderItems={this.setReorderItems}
                                                      reorderParams={this.state.reorderParams}
                                    />
                                })}
                            </div>
                        </div>
                        <hr/>

                        {/*<div className="title-background2-responsive">*/}
                        {/*<FormattedMessage id="app.order.history.table-header.order-file"*/}
                        {/*defaultMessage="Product File"*/}
                        {/*description=""/>*/}
                        {/*</div>*/}

                        {/*<hr/>*/}
                        <div>
                            <div className="title-background2-responsive ">

                                <div className='custom-col-4'></div>
                                <div className="custom-col-6 text-align-cus-order">
                                    <FormattedMessage id="app.order.history.table-header.order-price"
                                                      defaultMessage="Price"
                                                      description=""/>
                                </div>
                                <div className="custom-col-1 float-right-plus btnCollapse">
                                    <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                    <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                                </div>
                                <div className="custom-col-1"></div>

                            </div>
                            <div className="collapseContent set-padding-collapse-content">
                                <FormattedMessage id="app.order.history.table.order-merchandise-total"
                                                  defaultMessage="Merchandise Total"
                                                  description=""/><br/>
                                <label className="total-order-item-responsive ">
                                    ¥<NumberFormatter num={this.props.order.orderTotal}/>
                                </label>
                            </div>
                        </div>
                        <hr/>


                        <div>
                            <div className="title-background2-responsive ">
                                <div className='custom-col-4'></div>
                                <div className="custom-col-6 text-align-cus-order">
                                    <FormattedMessage id="app.order.history.table-header.order-status"
                                                      defaultMessage="Order Status"
                                                      description=""/>
                                </div>
                                <div className="custom-col-1 float-right-plus btnCollapse">
                                    <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                    <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                                </div>
                                <div className="custom-col-1"></div>

                            </div>
                            <div className="collapseContent set-padding-collapse-content">
                                <div className="spacer"></div>
                                <GetStatusLocale status={this.props.order.status}/>
                                <br/>
                                <FormattedMessage id="app.order.history.table.shipping-method"
                                                  defaultMessage="Shipping Method"
                                                  description=""/> :<br/>SGX(佐川国際宅配便)<br/>
                                <a className="" onClick={this.handleShow}>
                                    <span>
                                        <FormattedMessage id="app.admin-all-row.track"
                                                          defaultMessage="Track"
                                                          description=""/>
                                        </span>
                                </a>
                            </div>
                        </div>
                        <hr/>
                        <div>
                            <div className="title-background2-responsive ">

                                <div className='custom-col-4'></div>
                                <div className="custom-col-6 text-align-cus-order">
                                    <FormattedMessage id="app.order.history.table-header.order-operate"
                                                      defaultMessage="Operate"
                                                      description=""/>
                                </div>
                                <div className="custom-col-1 float-right-plus btnCollapse">
                                    <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                    <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                                </div>
                                <div className="custom-col-1"></div>


                            </div>
                            <div className="collapseContent set-padding-collapse-content">
                                <div className="spacer"></div>
                                <Link to={"/order/view/" + this.props.order.id} className="view-act-btn">
                                    <FormattedMessage id="app.admin-all-row.view-order"
                                                      defaultMessage="Order Details"
                                                      description=""/>
                                </Link><br/>
                                {this.state.stat === '' ?
                                    <PrintOrder orderId={this.props.order.id}
                                                orderStat={unavailableStatus}
                                                batchNumber={this.props.order.batchNumber}/> :
                                    <PrintOrder orderId={this.props.order.id}
                                                orderStat={this.state.stat}
                                                batchNumber={this.props.order.batchNumber}/>
                                }
                                <br/>
                                {this.props.order.refunded ?
                                    <button disabled={true} className="">
                                        払い戻し済み
                                    </button>
                                    :
                                    ""
                                }
                            </div>
                        </div>


                    </div>
                </div>


                <Modal show={this.state.showReorderConfirm} onHide={this.handleCloseReorderConfirm}
                       className="track-order-modal">
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            再注文確認
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            この製品を再注文しますか？
                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-offset-2 pull-right color-text">

                            <button className="btn btn-info reorder-btns"
                                    onClick={() => this.createReorder(this.props.order.id)}>
                                はい
                            </button>
                            &nbsp;
                            <button className="btn btn-primary reorder-btns" onClick={this.handleCloseReorderConfirm}>
                                いいえ
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

                <Modal show={this.state.show} onHide={this.handleClose} className="track-order-modal">
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            輸送状況の確認&nbsp;
                            {/*<span>{this.props.order.batchNumber}</span>*/}
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-4">
                                    <label>注文番号
                                        &nbsp;: </label>
                                </div>
                                <div className="col-md-4 pull-left">
                                    <span>{this.props.order.batchNumber}</span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label> <FormattedMessage id="app.site.track.production.order-no"
                                                              defaultMessage="Order Date"
                                                              description=""/> &nbsp;:</label>
                                </div>
                                <div className="col-md-4 pull-left">
                                    <span>
                                        {this.props.order.createdOn.substring(0, 4)} 年 {this.props.order.createdOn.substring(5, 7)} 月 {this.props.order.createdOn.substring(8, 10)} 日
                                    </span>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <label><FormattedMessage id="app.site.track.production.order-status"
                                                             defaultMessage="Order Status"
                                                             description=""/>&nbsp;: </label>
                                </div>
                                <div className="col-md-4 pull-left">
                                <span>

                                    {/*{this.state.statusCode}*/}
                                    {/*{this.state.orderData.status}*/}
                                    {/*{this.state.status}*/}
                                    <GetStatusLocale status={this.props.order.status}/>
                                </span>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-md-4">
                                    <label><FormattedMessage id="app.order.confirm.shipping.address"
                                                             defaultMessage="Shipping Address"
                                                             description=""/>&nbsp;: </label>
                                </div>
                                <div className="col-md-4 pull-left">
                                    {/*<div>{this.props.order.orderInfo.shippingAddress.address}</div>
                                <br/>*/}
                                    <div>〒{this.props.order.orderInfo.shippingAddress.postalCode}</div>
                                    <div>{this.props.order.orderInfo.shippingAddress.province}</div>
                                    <div>{this.props.order.orderInfo.shippingAddress.city}</div>
                                    <div>{this.props.order.orderInfo.shippingAddress.streetAddress}</div>
                                    <div>{this.props.order.orderInfo.shippingAddress.addressLine2}</div>


                                </div>
                            </div>
                            <br/>
                            <div className="row">
                                <div className="col-md-4">
                                    <label><FormattedMessage id="app.order.history.table.shipping-method"
                                                             defaultMessage="Shipping Method"
                                                             description=""/>&nbsp;: </label>
                                </div>
                                <div className="col-md-5 pull-left">
                                <span>
                                    {/*{this.props.shipping}*/}
                                    <a href="https://www.sgh-globalj.com/" target="_blank"> SGX（佐川国際宅配便）</a>
                                </span>
                                </div>
                            </div>
                            {/*<div className="row">

                            <div className="col-md-4">
                                <label>Total Carriage Money: </label>
                            </div>
                            <div className="col-md-4 pull-left">
                                <span>{this.props.shipping}</span>
                            </div>
                        </div>*/}
                            {/*<div className="row">*/}

                            {/*<div className="col-md-4">*/}
                            {/*<label><FormattedMessage id="app.order.history.item.build"*/}
                            {/*defaultMessage="Build Time"*/}
                            {/*description=""/>&nbsp;: </label>*/}
                            {/*</div>*/}
                            {/*{this.state.orderItems.map(orderItems => {*/}
                            {/*let orderTotalJson = JSON.parse(orderItems.chargeDetails.priceInfoJson);*/}
                            {/*let deliveryDate = orderTotalJson.deliveryDate;*/}
                            {/*if (deliveryDate > initDeliveryDate) {*/}
                            {/*initDeliveryDate = deliveryDate;*/}
                            {/*}*/}
                            {/*build = orderItems.chargeDetails.buildTime;*/}

                            {/*})}*/}

                            {/*<div className="col-md-4 pull-left">*/}
                            {/*<span>*/}
                            {/*{Math.max.apply(Math, this.state.buildTimeArray)}&nbsp;*/}
                            {/*<FormattedMessage id="app.quotation.price-info.build-hours"*/}
                            {/*defaultMessage="hours"*/}
                            {/*description=""/>*/}
                            {/*</span>*/}
                            {/*</div>*/}
                            {/*</div>*/}
                            {/*{console.log("shippeddate",this.props.order.shippedDate,this.props.order.deliveryDate)}*/}
                            {this.props.order.shippedDate !== null &&
                            // {this.props.order.status==='SHIPPED' &&

                            <div>
                                <div className="row">

                                    <div className="col-md-4">
                                        <label>
                                            {/*<FormattedMessage id="app.price.info.delivery.time"
                                                                 defaultMessage="Delivery Date"
                                                                 description=""/>*/}
                                            {/*配送日*/}
                                            出荷日
                                            &nbsp;: </label>
                                    </div>
                                    <div className="col-md-4 pull-left">
                                        <span>
                                            {/*{this.props.order.deliveryDate.substring(0, 4)} 年 {this.props.order.deliveryDate.substring(5, 7)} 月 {this.props.order.deliveryDate.substring(8, 10)} 日*/}
                                            {this.props.order.shippedDate.substring(0, 4)} 年 {this.props.order.shippedDate.substring(5, 7)} 月 {this.props.order.shippedDate.substring(8, 10)} 日
                                        </span>
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-md-4">
                                        <label>

                                            問合せ番号
                                            &nbsp;: </label>
                                    </div>
                                    <div className="col-md-4 pull-left">
                                    <span>
                                        {
                                            this.state.sagawaCodes.length > 0 &&
                                            <text>{this.state.sagawaCodes[0].substring(1, 13)}</text>
                                        }
                                    </span>
                                    </div>
                                </div>
                            </div>

                            }

                        </div>

                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-offset-2 pull-right color-text">
                            <button className="btn btn-info' bottom-button" onClick={this.handleClose}>
                                <FormattedMessage id="app.admin.change.status.close"
                                                  defaultMessage="Close "
                                                  description=""/>
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>

            </div>
        );
    }

}

export default CustomerOrderTableRow;



// WEBPACK FOOTER //
// ./src/components/Site/Order/OrderHistory/CustomerOrderTableRow/CustomerOrderTableRow.js